export { default } from 'flows/core/pages/index';
